// src/hooks/productTypes/useUpdateProductType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateProductType } from "../../api/apiProductTypes";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateProductType = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateProductTypes, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateProductType(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Product type updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
            queryClient.invalidateQueries({ queryKey: ["productType"] });
            navigate("/product-types");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update product type");
        },
    });

    return { updateProductTypes, isUpdate };
};

export default useUpdateProductType;